import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class PaymentResultGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(): boolean {
        const paymentFlag = sessionStorage.getItem('payment_in_progress');

        if (!paymentFlag) {
            console.warn('Guard bloqueó acceso a payment-result');
            this.router.navigate(['/tienda']);
            return false;
        }

        return true;
    }
}